/**
 * 발주 개수 설정 모달 ($j.Ui.JBModal.target 결합).
 * 레거시 public/skw_3300_cntup.php 대체.
 *
 * 사용법:
 *   $j.Ui.JBModal.target('baljoo-cnt-modal', {
 *       target: '$j.F.Admin.Member.BaljooCntForm',
 *       data:   { mbNo: 123 },
 *       title:  '발주 개수 설정',
 *       width:  '500px',
 *   });
 */
export default class BaljooCntForm {
    constructor() { this.$wrap = null; }
    destroy() {}

    init() {
        this.mbNo = this.data.mbNo;
        $(`#${this.id}`).html('<div style="padding:20px;text-align:center;color:#888">로딩중...</div>');
        this.load();
    }

    load() {
        const self = this;
        $.ajax({
            type: 'get',
            url: '/adm/ajax/member/baljoo/cnt/form',
            data: { no: self.mbNo },
            dataType: 'json',
            success(data) {
                self.state = data;
                self.render();
                self.bind();
            },
            error() {
                $(`#${self.id}`).html('<div style="padding:20px;text-align:center;color:var(--adm-kw-red, red)">데이터를 불러오지 못했습니다.</div>');
            },
        });
    }

    render() {
        const s = this.state;
        const html = `
        <style>
            .baljoo-form .xtable { width:100%; border-collapse:collapse; }
            .baljoo-form .xtable th, .baljoo-form .xtable td { font-size:13px; border:1px solid #ccc; padding:8px 12px; }
            .baljoo-form .xtable th { background:#f0f0f0; text-align:left; white-space:nowrap; font-weight:bold; width:40%; }
            .baljoo-form .highlight { background-color:#C5C589; }
        </style>
        <div class="baljoo-form">
            <table class="xtable">
                <tr class="highlight">
                    <th><i class="fas fa-heart res-i is-odr"></i> 현재 발주 / 수주 개수</th>
                    <td>
                        <span style="color:var(--adm-kw-red, red);font-weight:bold">발주 : ${s.currentCnt}개</span> |
                        <span style="color:var(--adm-kw-blue, blue);font-weight:bold">수주 ${s.thisMonthSooCnt}개</span>
                    </td>
                </tr>
                <tr><th><i class="fas fa-heart res-i is-odr"></i> 계산된 발주개수</th><td>${s.baljooCnt}개</td></tr>
                <tr><th>총 수주개수</th><td>${s.soojoo}개</td></tr>
                <tr class="highlight">
                    <th style="color:var(--adm-kw-red, red);font-weight:bold"><i class="fas fa-heart res-i is-odr"></i> 변경할 발주개수</th>
                    <td><input type="text" id="baljoo-newvalue" style="width:60px;height:28px;padding:4px" value="${s.currentCnt}"> 개</td>
                </tr>
            </table>
            <div style="text-align:center;margin-top:20px">
                <button type="button" id="baljoo-save" style="width:100px;height:38px;background:#0a2383;color:#fff;border:none;border-radius:4px;cursor:pointer">적용하기</button>
            </div>
        </div>`;
        $(`#${this.id}`).html(html);
    }

    bind() {
        const self = this;
        $(`#${this.id}`).find('#baljoo-save').off('click').on('click', () => self.save());
    }

    save() {
        const vals = parseInt($(`#${this.id}`).find('#baljoo-newvalue').val(), 10);
        if (isNaN(vals)) { alert('발주 개수를 숫자만 입력해 주세요'); return; }
        if (!confirm(`선택한 회원의 발주 개수를 [ ${vals} ]개로 설정할까요?`)) return;

        $.ajax({
            type: 'POST',
            url: '/adm/ajax/member/baljoo/cnt/save',
            data: { no: this.mbNo, newvalue: vals },
            dataType: 'json',
            success(data) {
                if (data.result) {
                    $j.F.Admin.Util.tsalert('success', data.message);
                    $j.Ui.JBModal.close('baljoo-cnt-modal');
                    $('input[name="mem_order_cnt"]').val(vals);
                } else {
                    $j.F.Admin.Util.tsalert('error', data.message || '실패하였습니다.');
                }
            },
            error(xhr) {
                alert(`요청 중 오류가 발생했습니다. (${xhr.status})`);
            },
        });
    }
}
